function nameResource(overrides) {
	return Object.assign(
		{
			searchPlaceholder: '搜索名称',
			columns: [
				{ prop: 'id', label: 'ID', width: 60 },
				{ prop: 'name', label: '名称', minWidth: 160 },
				{ prop: 'createtime', label: '创建时间', width: 168, format: 'time' },
			],
			fields: [{ key: 'name', label: '名称', type: 'input', required: true }],
			defaultForm: { name: '' },
		},
		overrides || {},
	);
}

export const FRONT_ADMIN_RESOURCES = {
	auth_admin: {
		searchPlaceholder: '用户名 / 昵称 / 邮箱',
		columns: [
			{ prop: 'id', label: 'ID', width: 60 },
			{ prop: 'username', label: '用户名', minWidth: 110 },
			{ prop: 'nickname', label: '昵称', minWidth: 110 },
			{ prop: 'email', label: '邮箱', minWidth: 140 },
			{ prop: 'groups_text', label: '角色组', minWidth: 140 },
			{ prop: 'logintime', label: '登录时间', width: 168, format: 'time' },
		],
		fields: [
			{ key: 'username', label: '用户名', type: 'input', required: true },
			{ key: 'nickname', label: '昵称', type: 'input' },
			{ key: 'email', label: '邮箱', type: 'input' },
			{ key: 'password', label: '密码', type: 'password', placeholder: '编辑时留空则不改' },
			{ key: 'group_ids', label: '角色组', type: 'multiSelect', optionsAction: 'groupOptions', required: true },
		],
		defaultForm: { username: '', nickname: '', email: '', password: '', group_ids: [] },
	},
	auth_group: {
		searchPlaceholder: '角色组名称',
		ruleTree: 'roleTree',
		columns: [
			{ prop: 'id', label: 'ID', width: 60 },
			{ prop: 'name', label: '名称', minWidth: 140 },
			{ prop: 'status', label: '状态', width: 80 },
			{ prop: 'rules_text', label: '权限', minWidth: 200 },
		],
		fields: [
			{ key: 'name', label: '名称', type: 'input', required: true },
			{ key: 'pid', label: '上级 ID', type: 'number' },
			{ key: 'status', label: '状态', type: 'select', options: [{ value: 'normal', label: '正常' }, { value: 'hidden', label: '隐藏' }] },
			{ key: 'rules', label: '权限', type: 'ruleTree' },
		],
		defaultForm: { name: '', pid: 0, status: 'normal', rules: '' },
	},
	auth_rule: {
		searchPlaceholder: '标题 / 规则名',
		columns: [
			{ prop: 'id', label: 'ID', width: 60 },
			{ prop: 'title', label: '标题', minWidth: 140 },
			{ prop: 'name', label: '规则名', minWidth: 160 },
			{ prop: 'ismenu', label: '菜单', width: 72, format: 'bool' },
			{ prop: 'weigh', label: '权重', width: 72 },
			{ prop: 'status', label: '状态', width: 80 },
		],
		fields: [
			{ key: 'title', label: '标题', type: 'input', required: true },
			{ key: 'name', label: '规则名', type: 'input', required: true },
			{ key: 'pid', label: '上级 ID', type: 'number' },
			{ key: 'icon', label: '图标', type: 'input' },
			{ key: 'ismenu', label: '菜单', type: 'switch' },
			{ key: 'weigh', label: '权重', type: 'number' },
			{ key: 'status', label: '状态', type: 'select', options: [{ value: 'normal', label: '正常' }, { value: 'hidden', label: '隐藏' }] },
		],
		defaultForm: { title: '', name: '', pid: 0, icon: '', ismenu: true, weigh: 0, status: 'normal' },
	},
	auth_adminlog: {
		listOnly: true,
		searchPlaceholder: '用户名 / 标题 / URL',
		columns: [
			{ prop: 'id', label: 'ID', width: 60 },
			{ prop: 'username', label: '用户名', minWidth: 100 },
			{ prop: 'title', label: '标题', minWidth: 140 },
			{ prop: 'url', label: 'URL', minWidth: 180 },
			{ prop: 'ip', label: 'IP', width: 120 },
			{ prop: 'createtime', label: '时间', width: 168, format: 'time' },
		],
		fields: [],
		defaultForm: {},
	},
	user_user: {
		searchPlaceholder: '用户名 / 昵称 / 手机',
		columns: [
			{ prop: 'id', label: 'ID', width: 60 },
			{ prop: 'group_name', label: '会员组', minWidth: 100 },
			{ prop: 'username', label: '用户名', minWidth: 110 },
			{ prop: 'nickname', label: '昵称', minWidth: 110 },
			{ prop: 'mobile', label: '手机', width: 120 },
			{ prop: 'company_name', label: '公司', minWidth: 140 },
			{ prop: 'logintime', label: '登录时间', width: 168, format: 'time' },
		],
		fields: [
			{ key: 'username', label: '用户名', type: 'input', required: true },
			{ key: 'nickname', label: '昵称', type: 'input' },
			{ key: 'mobile', label: '手机', type: 'input' },
			{ key: 'email', label: '邮箱', type: 'input' },
			{ key: 'password', label: '密码', type: 'password', placeholder: '编辑时留空则不改' },
			{ key: 'group_id', label: '会员组', type: 'select', optionsAction: 'groupOptions', required: true },
			{ key: 'company_name', label: '公司', type: 'input' },
			{ key: 'pur_ratio', label: '采购比例', type: 'number' },
			{ key: 'is_distribution', label: '分销', type: 'switch' },
		],
		defaultForm: { username: '', nickname: '', mobile: '', email: '', password: '', group_id: 3, company_name: '', pur_ratio: 0, is_distribution: false },
	},
	user_user_indexs: {
		searchPlaceholder: '用户名 / 昵称 / 手机',
		columns: [
			{ prop: 'id', label: 'ID', width: 60 },
			{ prop: 'username', label: '用户名', minWidth: 110 },
			{ prop: 'nickname', label: '昵称', minWidth: 110 },
			{ prop: 'mobile', label: '手机', width: 120 },
			{ prop: 'company_name', label: '公司', minWidth: 140 },
			{ prop: 'createtime', label: '创建时间', width: 168, format: 'time' },
		],
		fields: [
			{ key: 'username', label: '用户名', type: 'input', required: true },
			{ key: 'nickname', label: '昵称', type: 'input' },
			{ key: 'mobile', label: '手机', type: 'input' },
			{ key: 'email', label: '邮箱', type: 'input' },
			{ key: 'password', label: '密码', type: 'password' },
			{ key: 'group_id', label: '会员组', type: 'select', optionsAction: 'groupOptions' },
			{ key: 'company_name', label: '公司', type: 'input' },
		],
		defaultForm: { username: '', nickname: '', mobile: '', email: '', password: '', group_id: 11, company_name: '' },
	},
	user_group: {
		searchPlaceholder: '会员组名称',
		ruleTree: 'ruletree',
		columns: [
			{ prop: 'id', label: 'ID', width: 60 },
			{ prop: 'name', label: '名称', minWidth: 140 },
			{ prop: 'status', label: '状态', width: 80 },
			{ prop: 'rules_count', label: '权限数', width: 80 },
			{ prop: 'rules_text', label: '权限', minWidth: 200 },
		],
		fields: [
			{ key: 'name', label: '名称', type: 'input', required: true },
			{ key: 'status', label: '状态', type: 'select', options: [{ value: 'normal', label: '正常' }, { value: 'hidden', label: '隐藏' }] },
			{ key: 'default_quotation_category_id', label: '默认分类 ID', type: 'number' },
			{ key: 'rules', label: 'C 端权限', type: 'ruleTree' },
		],
		defaultForm: { name: '', status: 'normal', default_quotation_category_id: 0, rules: '' },
	},
	user_rule: {
		listOnly: true,
		searchPlaceholder: '名称 / 标题',
		columns: [
			{ prop: 'id', label: 'ID', width: 60 },
			{ prop: 'display_title', label: '标题', minWidth: 140 },
			{ prop: 'name', label: '规则名', minWidth: 140 },
			{ prop: 'ismenu', label: '板块', width: 72, format: 'bool' },
			{ prop: 'weigh', label: '权重', width: 72 },
			{ prop: 'status', label: '状态', width: 80 },
		],
		fields: [],
		defaultForm: {},
	},
	category: {
		searchPlaceholder: '分类名称',
		parentOptions: true,
		columns: [
			{ prop: 'id', label: 'ID', width: 60 },
			{ prop: 'name_display', label: '名称', minWidth: 180 },
			{ prop: 'weigh', label: '排序', width: 72 },
			{ prop: 'createtime', label: '创建时间', width: 168, format: 'time' },
		],
		fields: [
			{ key: 'name', label: '名称', type: 'input', required: true },
			{ key: 'pid', label: '上级', type: 'parentSelect' },
			{ key: 'weigh', label: '排序', type: 'number' },
			{ key: 'image', label: '图片', type: 'input' },
			{ key: 'content', label: '描述', type: 'textarea' },
		],
		defaultForm: { name: '', pid: 0, weigh: 0, image: '', content: '' },
	},
	invoice: nameResource(),
	transport: nameResource(),
	colour: nameResource(),
	direction: nameResource(),
	loyal: nameResource(),
	switchs: nameResource({
		columns: [
			{ prop: 'id', label: 'ID', width: 60 },
			{ prop: 'name', label: '名称', minWidth: 140 },
			{ prop: 'price', label: '价格', width: 100, format: 'money' },
			{ prop: 'createtime', label: '创建时间', width: 168, format: 'time' },
		],
		fields: [
			{ key: 'name', label: '名称', type: 'input', required: true },
			{ key: 'price', label: '价格', type: 'number' },
		],
		defaultForm: { name: '', price: 0 },
	}),
	sorting: nameResource({
		fields: [
			{ key: 'name', label: '名称', type: 'input', required: true },
			{ key: 'weigh', label: '排序', type: 'number' },
		],
		defaultForm: { name: '', weigh: 0 },
	}),
	news: {
		searchPlaceholder: '标题',
		columns: [
			{ prop: 'id', label: 'ID', width: 60 },
			{ prop: 'title', label: '标题', minWidth: 180 },
			{ prop: 'status_text', label: '状态', width: 80 },
			{ prop: 'weigh', label: '排序', width: 72 },
			{ prop: 'createtime', label: '创建时间', width: 168, format: 'time' },
		],
		fields: [
			{ key: 'title', label: '标题', type: 'input', required: true },
			{ key: 'image', label: '图片', type: 'input' },
			{ key: 'describe', label: '摘要', type: 'textarea' },
			{ key: 'content', label: '内容', type: 'textarea' },
			{ key: 'status', label: '状态', type: 'select', options: [{ value: '1', label: '正常' }, { value: '0', label: '隐藏' }] },
			{ key: 'weigh', label: '排序', type: 'number' },
		],
		defaultForm: { title: '', image: '', describe: '', content: '', status: '1', weigh: 0 },
	},
	activity: {
		searchPlaceholder: '标题',
		columns: [
			{ prop: 'id', label: 'ID', width: 60 },
			{ prop: 'title', label: '标题', minWidth: 180 },
			{ prop: 'url', label: '链接', minWidth: 160 },
			{ prop: 'createtime', label: '创建时间', width: 168, format: 'time' },
		],
		fields: [
			{ key: 'title', label: '标题', type: 'input', required: true },
			{ key: 'image', label: '图片', type: 'input' },
			{ key: 'url', label: '外链', type: 'input' },
			{ key: 'type', label: '类型', type: 'input' },
			{ key: 'weigh', label: '排序', type: 'number' },
		],
		defaultForm: { title: '', image: '', url: '', type: '', weigh: 0 },
	},
	shop: {
		searchPlaceholder: '店铺名称',
		columns: [
			{ prop: 'id', label: 'ID', width: 60 },
			{ prop: 'name', label: '名称', minWidth: 140 },
			{ prop: 'address', label: '地址', minWidth: 180 },
			{ prop: 'createtime', label: '创建时间', width: 168, format: 'time' },
		],
		fields: [
			{ key: 'name', label: '名称', type: 'input', required: true },
			{ key: 'address', label: '地址', type: 'input' },
			{ key: 'image', label: '图片', type: 'input' },
			{ key: 'lng', label: '经度', type: 'input' },
			{ key: 'lat', label: '纬度', type: 'input' },
		],
		defaultForm: { name: '', address: '', image: '', lng: '', lat: '' },
	},
	join: {
		listOnly: true,
		searchPlaceholder: '姓名 / 电话',
		columns: [
			{ prop: 'id', label: 'ID', width: 60 },
			{ prop: 'name', label: '姓名', minWidth: 100 },
			{ prop: 'mobile', label: '电话', width: 120 },
			{ prop: 'createtime', label: '创建时间', width: 168, format: 'time' },
		],
		fields: [],
		defaultForm: {},
	},
	message: {
		listOnly: true,
		searchPlaceholder: '留言',
		columns: [
			{ prop: 'id', label: 'ID', width: 60 },
			{ prop: 'name', label: '姓名', minWidth: 100 },
			{ prop: 'content', label: '内容', minWidth: 200 },
			{ prop: 'createtime', label: '创建时间', width: 168, format: 'time' },
		],
		fields: [],
		defaultForm: {},
	},
	product: {
		searchPlaceholder: '产品名称',
		columns: [
			{ prop: 'id', label: 'ID', width: 60 },
			{ prop: 'name', label: '名称', minWidth: 160 },
			{ prop: 'sorting_name', label: '分类', minWidth: 100 },
			{ prop: 'createtime', label: '创建时间', width: 168, format: 'time' },
		],
		fields: [
			{ key: 'name', label: '名称', type: 'input', required: true },
			{ key: 'sorting_id', label: '分类 ID', type: 'number' },
			{ key: 'image', label: '图片', type: 'input' },
			{ key: 'content', label: '内容', type: 'textarea' },
		],
		defaultForm: { name: '', sorting_id: 0, image: '', content: '' },
	},
	collect: {
		listOnly: true,
		searchPlaceholder: '用户 / 商品',
		columns: [
			{ prop: 'id', label: 'ID', width: 60 },
			{ prop: 'user_id', label: '用户', width: 80 },
			{ prop: 'product_id', label: '产品', width: 80 },
			{ prop: 'createtime', label: '创建时间', width: 168, format: 'time' },
		],
		fields: [],
		defaultForm: {},
	},
	vrgoods: nameResource({
		fields: [
			{ key: 'name', label: '名称', type: 'input', required: true },
			{ key: 'image', label: '图片', type: 'input' },
			{ key: 'url', label: 'VR 地址', type: 'input' },
		],
		defaultForm: { name: '', image: '', url: '' },
	}),
	models: {
		searchPlaceholder: '模型标题',
		columns: [
			{ prop: 'id', label: 'ID', width: 60 },
			{ prop: 'title', label: '标题', minWidth: 160 },
			{ prop: 'status', label: '状态', width: 80, format: 'bool' },
			{ prop: 'createtime', label: '创建时间', width: 168, format: 'time' },
		],
		fields: [
			{ key: 'title', label: '标题', type: 'input', required: true },
			{ key: 'image', label: '图片', type: 'input' },
			{ key: 'glb', label: 'GLB', type: 'input' },
			{ key: 'hdr', label: 'HDR', type: 'input' },
			{ key: 'status', label: '启用', type: 'switch' },
		],
		defaultForm: { title: '', image: '', glb: '', hdr: '', status: true },
	},
	wares: {
		searchPlaceholder: '定制商品',
		columns: [
			{ prop: 'id', label: 'ID', width: 60 },
			{ prop: 'name', label: '名称', minWidth: 160 },
			{ prop: 'classify_name', label: '分类', minWidth: 100 },
			{ prop: 'type_text', label: '类型', width: 100 },
			{ prop: 'createtime', label: '创建时间', width: 168, format: 'time' },
		],
		fields: [
			{ key: 'name', label: '名称', type: 'input', required: true },
			{ key: 'classify_id', label: '分类 ID', type: 'number' },
			{ key: 'price', label: '价格', type: 'number' },
			{ key: 'detail', label: '详情', type: 'textarea' },
		],
		defaultForm: { name: '', classify_id: 0, price: 0, detail: '' },
	},
	transfer: {
		listOnly: true,
		searchPlaceholder: '用户 / 单号',
		columns: [
			{ prop: 'id', label: 'ID', width: 60 },
			{ prop: 'user_id', label: '用户', width: 80 },
			{ prop: 'money', label: '金额', width: 100, format: 'money' },
			{ prop: 'partner_trade_no', label: '单号', minWidth: 140 },
			{ prop: 'createtime', label: '创建时间', width: 168, format: 'time' },
		],
		fields: [],
		defaultForm: {},
	},
	classify: {
		searchPlaceholder: '分类名称',
		parentOptions: true,
		columns: [
			{ prop: 'id', label: 'ID', width: 60 },
			{ prop: 'name', label: '名称', minWidth: 160 },
			{ prop: 'pid', label: '上级', width: 80 },
			{ prop: 'weigh', label: '排序', width: 72 },
		],
		fields: [
			{ key: 'name', label: '名称', type: 'input', required: true },
			{ key: 'pid', label: '上级', type: 'parentSelect' },
			{ key: 'weigh', label: '排序', type: 'number' },
		],
		defaultForm: { name: '', pid: 0, weigh: 0 },
	},
	wares_order: {
		noCreate: true,
		searchPlaceholder: '订单 / 用户',
		columns: [
			{ prop: 'id', label: 'ID', width: 60 },
			{ prop: 'order_sn', label: '单号', minWidth: 140 },
			{ prop: 'name', label: '商品', minWidth: 140 },
			{ prop: 'createtime', label: '创建时间', width: 168, format: 'time' },
		],
		fields: [
			{ key: 'contacts', label: '收货人', type: 'input' },
			{ key: 'mobile', label: '电话', type: 'input' },
			{ key: 'address', label: '地址', type: 'input' },
		],
		defaultForm: { contacts: '', mobile: '', address: '' },
	},
	price: {
		searchPlaceholder: '规格值',
		columns: [
			{ prop: 'id', label: 'ID', width: 60 },
			{ prop: 'user_name', label: '用户', minWidth: 100 },
			{ prop: 'goods_name', label: '商品', minWidth: 120 },
			{ prop: 'price', label: '价格', width: 100, format: 'money' },
			{ prop: 'specs_value', label: '规格', minWidth: 140 },
		],
		fields: [
			{ key: 'user_id', label: '用户 ID', type: 'number', required: true },
			{ key: 'goods_id', label: '商品 ID', type: 'number', required: true },
			{ key: 'price', label: '价格', type: 'number' },
			{ key: 'specs_value', label: '规格值', type: 'textarea' },
		],
		defaultForm: { user_id: 0, goods_id: 0, price: 0, specs_value: '' },
	},
	cart: {
		listOnly: true,
		searchPlaceholder: '用户 / 商品',
		columns: [
			{ prop: 'id', label: 'ID', width: 60 },
			{ prop: 'user_id', label: '用户', width: 80 },
			{ prop: 'goods_id', label: '商品', width: 80 },
			{ prop: 'createtime', label: '创建时间', width: 168, format: 'time' },
		],
		fields: [],
		defaultForm: {},
	},
	transient: {
		listOnly: true,
		searchPlaceholder: '关键字',
		columns: [
			{ prop: 'id', label: 'ID', width: 60 },
			{ prop: 'name', label: '名称', minWidth: 140 },
			{ prop: 'createtime', label: '创建时间', width: 168, format: 'time' },
		],
		fields: [],
		defaultForm: {},
	},
	sku_price: {
		searchPlaceholder: '商品 / 规格',
		columns: [
			{ prop: 'id', label: 'ID', width: 60 },
			{ prop: 'goods_id', label: '商品 ID', width: 88 },
			{ prop: 'price', label: '价格', width: 100, format: 'money' },
			{ prop: 'createtime', label: '创建时间', width: 168, format: 'time' },
		],
		fields: [
			{ key: 'goods_id', label: '商品 ID', type: 'number', required: true },
			{ key: 'price', label: '价格', type: 'number' },
			{ key: 'specs', label: '规格', type: 'input' },
		],
		defaultForm: { goods_id: 0, price: 0, specs: '' },
	},
	goods_specs: {
		searchPlaceholder: '商品 / 规格',
		columns: [
			{ prop: 'id', label: 'ID', width: 60 },
			{ prop: 'goods_id', label: '商品 ID', width: 88 },
			{ prop: 'price', label: '价格', width: 100, format: 'money' },
			{ prop: 'createtime', label: '创建时间', width: 168, format: 'time' },
		],
		fields: [
			{ key: 'goods_id', label: '商品 ID', type: 'number', required: true },
			{ key: 'price', label: '价格', type: 'number' },
			{ key: 'specs', label: '规格', type: 'input' },
		],
		defaultForm: { goods_id: 0, price: 0, specs: '' },
	},
	sku: {
		searchPlaceholder: '规格名',
		columns: [
			{ prop: 'id', label: 'ID', width: 60 },
			{ prop: 'goods_id', label: '商品 ID', width: 88 },
			{ prop: 'goods_name', label: '商品', minWidth: 120 },
			{ prop: 'name', label: '规格名', minWidth: 140 },
			{ prop: 'pid', label: '上级', width: 72 },
			{ prop: 'weigh', label: '排序', width: 72 },
		],
		fields: [
			{ key: 'goods_id', label: '商品 ID', type: 'number', required: true },
			{ key: 'name', label: '名称', type: 'input', required: true },
			{ key: 'pid', label: '上级 ID', type: 'number' },
			{ key: 'weigh', label: '排序', type: 'number' },
		],
		defaultForm: { goods_id: 0, name: '', pid: 0, weigh: 0 },
	},
	sssp: {
		searchPlaceholder: '销售商品',
		columns: [
			{ prop: 'id', label: 'ID', width: 60 },
			{ prop: 'name', label: '名称', minWidth: 160 },
			{ prop: 'model', label: '型号', minWidth: 120 },
			{ prop: 'createtime', label: '创建时间', width: 168, format: 'time' },
		],
		fields: [
			{ key: 'name', label: '名称', type: 'input', required: true },
			{ key: 'model', label: '型号', type: 'input' },
			{ key: 'category_id', label: '分类 ID', type: 'number' },
		],
		defaultForm: { name: '', model: '', category_id: 0 },
	},
	money: { kind: 'money' },
	order: {
		noCreate: true,
		searchPlaceholder: '单号 / 联系人 / 电话',
		columns: [
			{ prop: 'id', label: 'ID', width: 60 },
			{ prop: 'order_number', label: '报价单号', minWidth: 140 },
			{ prop: 'user.nickname', label: '会员', width: 100, nested: 'user.nickname' },
			{ prop: 'contacts', label: '联系人', width: 90 },
			{ prop: 'contacts_phone', label: '电话', width: 120 },
			{ prop: 'customer.name', label: '客户', minWidth: 100, nested: 'customer.name' },
			{ prop: 'category_name', label: '分类', minWidth: 100 },
			{ prop: 'total', label: '金额', width: 90, format: 'money' },
			{ prop: 'place_order_status_text', label: '下单', width: 88 },
			{ prop: 'pay_status_text', label: '付款', width: 80 },
			{ prop: 'status_text', label: '状态', width: 80 },
			{ prop: 'createtime', label: '创建时间', width: 168, format: 'time' },
		],
		fields: [
			{ key: 'order_number', label: '单号', type: 'input', disabled: true },
			{ key: 'contacts', label: '联系人', type: 'input' },
			{ key: 'contacts_phone', label: '电话', type: 'input' },
			{ key: 'receiving_address', label: '收货地址', type: 'input' },
			{ key: 'total', label: '金额', type: 'number' },
			{ key: 'place_order_status', label: '下单状态', type: 'select', options: [{ value: '1', label: '待安排' }, { value: '2', label: '安排生产' }] },
			{ key: 'pay_status', label: '付款状态', type: 'select', options: [{ value: '1', label: '未付款' }, { value: '2', label: '已付款' }, { value: '3', label: '售后补单' }] },
			{ key: 'status', label: '订单状态', type: 'select', options: [{ value: '1', label: '待处理' }, { value: '2', label: '已发货' }] },
			{ key: 'remarks', label: '备注', type: 'textarea' },
		],
		defaultForm: { order_number: '', contacts: '', contacts_phone: '', receiving_address: '', total: 0, place_order_status: '1', pay_status: '1', status: '1', remarks: '' },
	},
	order_goods: {
		listOnly: true,
		searchPlaceholder: '商品 / 型号',
		columns: [
			{ prop: 'id', label: 'ID', width: 60 },
			{ prop: 'name', label: '商品', minWidth: 140 },
			{ prop: 'model', label: '型号', minWidth: 100 },
			{ prop: 'num', label: '数量', width: 72 },
			{ prop: 'price', label: '单价', width: 90, format: 'money' },
		],
		fields: [],
		defaultForm: {},
	},
	order_wares: {
		listOnly: true,
		searchPlaceholder: '商品',
		columns: [
			{ prop: 'id', label: 'ID', width: 60 },
			{ prop: 'name', label: '商品', minWidth: 140 },
			{ prop: 'createtime', label: '创建时间', width: 168, format: 'time' },
		],
		fields: [],
		defaultForm: {},
	},
	order_distribution: {
		searchPlaceholder: '订单 / 用户 ID',
		columns: [
			{ prop: 'id', label: 'ID', width: 60 },
			{ prop: 'order_number', label: '报价单号', minWidth: 130 },
			{ prop: 'user_name', label: '分销员', width: 100 },
			{ prop: 'money', label: '佣金', width: 90, format: 'money' },
			{ prop: 'level_text', label: '级别', width: 72 },
			{ prop: 'createtime', label: '创建时间', width: 168, format: 'time' },
		],
		fields: [
			{ key: 'order_id', label: '订单 ID', type: 'number', required: true },
			{ key: 'user_id', label: '用户 ID', type: 'number', required: true },
			{ key: 'user_ids', label: '客户 ID', type: 'number' },
			{ key: 'before', label: '变动前', type: 'number' },
			{ key: 'money', label: '佣金', type: 'number' },
			{ key: 'after', label: '变动后', type: 'number' },
			{ key: 'level', label: '级别', type: 'number' },
		],
		defaultForm: { order_id: 0, user_id: 0, user_ids: 0, before: 0, money: 0, after: 0, level: 1 },
	},
	s_order: {
		noCreate: true,
		searchPlaceholder: '单号 / 客户',
		columns: [
			{ prop: 'id', label: 'ID', width: 60 },
			{ prop: 'order_number', label: '单号', minWidth: 140 },
			{ prop: 'user.nickname', label: '用户', width: 100, nested: 'user.nickname' },
			{ prop: 'customer.name', label: '客户', minWidth: 100, nested: 'customer.name' },
			{ prop: 'purchase', label: '采购额', width: 90, format: 'money' },
			{ prop: 'purchase_status_text', label: '采购状态', width: 96 },
		],
		fields: [
			{ key: 'order_number', label: '单号', type: 'input', disabled: true },
			{ key: 'contacts', label: '联系人', type: 'input' },
			{ key: 'contacts_phone', label: '电话', type: 'input' },
			{ key: 'remarks', label: '备注', type: 'textarea' },
		],
		defaultForm: { order_number: '', contacts: '', contacts_phone: '', remarks: '' },
	},
	prints: {
		listOnly: true,
		searchPlaceholder: '单号',
		columns: [
			{ prop: 'id', label: 'ID', width: 60 },
			{ prop: 'order_number', label: '报价单号', minWidth: 140 },
			{ prop: 'createtime', label: '创建时间', width: 168, format: 'time' },
		],
		fields: [],
		defaultForm: {},
	},
};

export const FRONT_ADMIN_MODULES = {
	auth: {
		title: '权限管理',
		aside: '10',
		rule: 'auth_manage',
		desc: '维护管理员账号、角色组与菜单规则',
		sections: [
			{ key: 'admin', title: '管理员', desc: '后台管理员账号与角色分配', resource: 'auth_admin' },
			{ key: 'adminlog', title: '管理员日志', desc: '操作审计记录', resource: 'auth_adminlog' },
			{ key: 'group', title: '角色组', desc: '角色及其后台权限树', resource: 'auth_group' },
			{ key: 'rule', title: '权限规则', desc: '后台菜单与权限节点', resource: 'auth_rule' },
		],
	},
	member: {
		title: '会员管理',
		aside: '11',
		rule: 'member_manage',
		desc: '维护 C 端会员、会员组与前台权限',
		sections: [
			{ key: 'user', title: '会员管理', desc: '常规会员账号', resource: 'user_user' },
			{ key: 'indexs', title: '新会员管理', desc: '新会员分组账号', resource: 'user_user_indexs' },
			{ key: 'group', title: '会员组', desc: '会员组与 C 端板块权限', resource: 'user_group' },
			{ key: 'rule', title: '会员规则', desc: 'C 端权限节点只读查看', resource: 'user_rule' },
			{ key: 'transfer', title: '用户提现', desc: '提现记录', resource: 'transfer' },
			{ key: 'money', title: '会员提现', desc: '微信企业付款', resource: 'money' },
		],
	},
	settings: {
		title: '设置管理',
		aside: '12',
		rule: 'settings_manage',
		desc: '基础字典设置',
		sections: [
			{ key: 'colour', title: '型材颜色', desc: '颜色字典', resource: 'colour' },
			{ key: 'direction', title: '出线方向', desc: '出线方向字典', resource: 'direction' },
			{ key: 'switchs', title: '集成开关', desc: '开关及加价', resource: 'switchs' },
			{ key: 'invoice', title: '发票类型', desc: '发票类型字典', resource: 'invoice' },
			{ key: 'transport', title: '货物运输', desc: '运输方式字典', resource: 'transport' },
		],
	},
	quote: {
		title: '报价单管理',
		aside: '13',
		rule: 'quote_manage',
		desc: '后台视角维护全部报价单',
		sections: [
			{ key: 'order', title: '报价单管理', desc: '全部报价单编辑与删除', resource: 'order' },
		],
	},
};

/** 与后台 fa_auth_rule 侧栏一致：仅 ismenu 真实子项 */
export const PRODUCT_MANAGE_SECTIONS = [
	{ key: 'goods', title: '商品管理' },
	{ key: 'extra', title: '附加项设置' },
	{ key: 'factoryStock', title: '工厂库存' },
	{ key: 'parameter', title: '参数管理' },
];

const SIDEBAR_GROUP_META = {
	product: { title: '产品管理', rule: 'goods_manage', icon: 'list.png', path: '/productManage', sections: PRODUCT_MANAGE_SECTIONS },
	auth: { icon: 'center.png', path: '/authManage' },
	member: { icon: 'user.png', path: '/memberManage' },
	settings: { icon: 'list.png', path: '/settingsManage' },
	quote: { icon: 'bjcx.png', path: '/quoteManage' },
};

export const FRONT_SIDEBAR_GROUPS = ['product', 'auth', 'member', 'settings', 'quote'].map((key) => {
	const meta = SIDEBAR_GROUP_META[key];
	const module = FRONT_ADMIN_MODULES[key];
	const sections = meta.sections || (module && module.sections) || [];
	return {
		key,
		title: (module && module.title) || meta.title,
		rule: (module && module.rule) || meta.rule,
		icon: meta.icon,
		path: meta.path,
		children: sections.map((s) => ({ key: s.key, title: s.title, url: `${meta.path}?section=${s.key}` })),
	};
});

export function hasFrontAdminRule(ruleList, moduleRule) {
	if (!ruleList) return false;
	return !!(ruleList[moduleRule] || ruleList.goods_manage);
}

export function frontAdminCan(ruleList, moduleRule, action) {
	if (!ruleList) return false;
	if (ruleList.goods_manage) return true;
	if (ruleList[`${moduleRule}_${action}`]) return true;
	return !!ruleList[moduleRule];
}
